import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowPathIcon, Cog8ToothIcon } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { PipelineSelectionDropdown } from "../../../../components/Dropdown/PipelineSelectionDropdown/PipelineSelectionDropdown";
import { LoadingOval } from "../../../../components/Loading/Loading";
import { OPEN_EDIT_PIPELINE_MODAL } from "../../../../constants";
import { ActivePipelineContext } from "../../../../providers/ActivePipelineContextProvider";
import { ModalContext } from "../../../../providers/ModalContextProvider";
function PipelineHeader() {
    const { state: { activePipeline, loading }, fetchAndSetPipelineData, } = useContext(ActivePipelineContext);
    const { modalDispatch } = useContext(ModalContext);
    const openEditPipelineModal = () => {
        if (!activePipeline) {
            return;
        }
        modalDispatch({
            type: OPEN_EDIT_PIPELINE_MODAL,
            payload: {
                pipelineToEdit: activePipeline,
            },
        });
    };
    if (!activePipeline) {
        return null;
    }
    return (_jsxs("div", { className: "wpqt-flex wpqt-items-center wpqt-gap-2 wpqt-py-5", children: [_jsxs("div", { children: [_jsxs("div", { className: "wpqt-flex wpqt-items-center wpqt-gap-2", children: [_jsx("div", { className: "wpqt-text-lg", children: activePipeline.name }), _jsx(Cog8ToothIcon, { className: "wpqt-icon-gray wpqt-size-6 wpqt-cursor-pointer hover:wpqt-text-qtBlueHover", onClick: openEditPipelineModal })] }), activePipeline.description && (_jsx("div", { className: "wpqt-italic", children: activePipeline.description }))] }), _jsxs("div", { className: "wpqt-ml-auto wpqt-flex wpqt-items-center wpqt-gap-3", children: [loading ? (_jsx(LoadingOval, { width: "24", height: "24" })) : (_jsx(ArrowPathIcon, { className: "wpqt-size-6 wpqt-cursor-pointer hover:wpqt-text-qtBlueHover", onClick: () => fetchAndSetPipelineData(activePipeline.id) })), _jsx(PipelineSelectionDropdown, {})] })] }));
}
export { PipelineHeader };
